import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://erp-cpn.lemueltech.com/',
  // baseURL: 'http://localhost:5500',
  // baseURL: 'http://192.168.0.179:5500',
  withCredentials: true
})

// export const ACCOUNTING_URL = 'http://localhost:7900/accounting';
export const ACCOUNTING_URL = 'https://caspian-finance-server-58e8b535cab0.herokuapp.com/accounting';
export default Axios;
